export default {
  metadata: null,
  passage: null,
  libraryTree: null,
};
